module.exports = __webpack_public_path__ + "img/teacher_view_students_overview_button.3108b517.jpg";